
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _200u3XR9KSpukK1UYL0dV_4B2lhd0_3zC1HSs8KfHtasasMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/200.vue?macro=true";
import { default as _404iXt53w40RWlZZUZt_2U_GlN3_gQfrKF_X6yKiG5t_45bQMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/404.vue?macro=true";
import { default as indexvrLs_45O6MobVvdekuoYB6orLUGYcge2YgmDO9_45eS_452tEMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/index.vue?macro=true";
import { default as index268lQ_g8gssklqajHfduwtzJ4sruwX18Q_Au6dbvZ_45oMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/study/index.vue?macro=true";
import { default as faqLv3495i8HlZp7iI8Ae62uNlyufh99hOxFG1esItSReIMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/about-us/faq.vue?macro=true";
import { default as _91slug_93I_ZDuNiRciiYaTelgU9TN2E7G3er2mM8raBpVeobFR0Meta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/study/[slug].vue?macro=true";
import { default as chat_45with_45asuwAF4ti5FUPw_45D4NU_45Wmb3U3M7GlxFcbYqVsES_QOgW4Meta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/chat-with-asu.vue?macro=true";
import { default as indexpsZ3jCJtl_v20MPICfBiLi3JbfybJMXG3QQPK7KhbPUMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/about-us/index.vue?macro=true";
import { default as indexmPyERBXw3U6ilf4USWIGzVcGan75Y8h6SsiHX27GtcAMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/newsroom/index.vue?macro=true";
import { default as index2U7R_zGZkZS68N43cXHpoghptZYsQ31mfB_453pCc6FSoMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/index.vue?macro=true";
import { default as indexXWyOwytar70zsOAg_45PsFRihEiuqot3YR9bnAJb0Eos8Meta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/admission/index.vue?macro=true";
import { default as facultyfEFvNsWNLK6KEcxF8zBgvFTqUfk5snx43TilZVjTsTwMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/about-us/faculty.vue?macro=true";
import { default as coursesnhgLQhEpZfReDeCSFV2mpKy6Hito7q1g9SaGwmlyY5UMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/courses.vue?macro=true";
import { default as reviews3J0JTXP9GsQDTcwpFZNvocwCHQfUl3N4p8bPWTbh1VgMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/reviews.vue?macro=true";
import { default as policiespcvy94K0lNqNcqOAHgoxa22v8qBFgn0FGTCymrc76BkMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/about-us/policies.vue?macro=true";
import { default as rankingsou0tftUX2_MGiu2i8fMXWmnKhnmD6sA5NFyA7jcU9Y0Meta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/about-us/rankings.vue?macro=true";
import { default as servicesOp2wEXnMMlD6CqG62S6_45rat5GHBcyapu6XmTGIRuivIMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/services.vue?macro=true";
import { default as tutoringJ1zc3x_JEpN3b_45U3xVRmWCcsc2wimwyNBgoe4vLlgbwMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/tutoring.vue?macro=true";
import { default as communityHOp4JhUO_45FlYXUqgmHfJ1DMQUFNPWRLlWU6YMpPHu2kMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/community.vue?macro=true";
import { default as contact_45uspiZU4L6SNN6j6_45QKxass_45VX1rSgqeiS4XTNxPbR2oSUMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/about-us/contact-us.vue?macro=true";
import { default as join_45asu_45sun_45devilsRb4_Pj6gDQ8OwWOkgXxF8REdSQ4XY2yc_CNvs7U6VTYMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/join-asu-sun-devils.vue?macro=true";
import { default as index2YqWgDN0Gr94QZst4cCWeYHtu2HIi12vPSEceSVjLucMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/what-it-costs/index.vue?macro=true";
import { default as online_45labsZ2rnx2GQCJmLipYmuVmC5ytNah9sVDtl5_nDJn6vd7IMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/online-labs.vue?macro=true";
import { default as study_45abroad3ZsA1_45nGSnHDkPyjE9fbPGTMtMPU9X_JvYLNd7yBApgMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/study-abroad.vue?macro=true";
import { default as success_45team9yeKK8Acwhd4y_Ny4Eo6lF_DmyN3MIh7xnYwZMLbax4Meta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/success-team.vue?macro=true";
import { default as accreditationsg2QheBuCt_45vH9xsLZRGPqbfMxo8pAxQU0PnDDbVzl0Meta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/about-us/accreditation.vue?macro=true";
import { default as index3ANIoMEkFcqnLXfeMtGpMtGSl5n_45uOxFI90_TB3HPS0Meta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/admission/[slug]/index.vue?macro=true";
import { default as why_45asu_45online20S9ihkpeRMjLakyXslCIjCQJxNiqfix6APmCRGbzWgMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/about-us/why-asu-online.vue?macro=true";
import { default as web_45analytics_45privacy_452WTn_hd_CJxlWyBgaQ84Vro3ujNBWrXRtIRI2hcvazMwMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/web-analytics-privacy-2.vue?macro=true";
import { default as index4RJkj9nqnMwVRPhHWIwggjugfC2_45n7DjkriiZO3TAHoMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/newsroom/[category]/index.vue?macro=true";
import { default as graduation_45beyond_45qJTkLNffAigdOV70CgL2S_pq6yX4EWCdkryymMDMwsMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/graduation-beyond.vue?macro=true";
import { default as indexB0isY0wT85uZMdRByM86GpkwLhWQSmajjzcmOlThXAkMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/admission/[slug]/apply/index.vue?macro=true";
import { default as indexAOC6NVCQ_45zkNInj34mHngRfBrlJY2WuU4sRgbmlUogEMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/online-degree-programs/index.vue?macro=true";
import { default as indexXCR_VPYR_45N4mZRVFQYgtGKAL3hp25DpY_45ZXGs12WM_45AMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/admission/nondegree/apply/index.vue?macro=true";
import { default as indexi1ZJU5jkrOBKI63M0Dfv8y00x__45npj8DKmhAOaymykMMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/what-it-costs/financial-aid/index.vue?macro=true";
import { default as indexx6wudrs0yUyW0bNlyTHrrdGnarUPDtu7k3gU3qWqqcAMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/what-it-costs/loan-estimator/index.vue?macro=true";
import { default as indexBmkStZhDPRpWkcAZ0JPkhAFaidCzOda3CqafvEzb_sEMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/newsroom/[category]/[article]/index.vue?macro=true";
import { default as indexeMT6CqX95g5XeeNK62M8o4t6UvjL_rAIvQ_45_45O2YoBjkMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/online-degree-programs/minors/index.vue?macro=true";
import { default as indexKTOn4dTL4P7iFZPBRceCww7sn9W24EmIrLhP3StjqoMMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/online-degree-programs/graduate/index.vue?macro=true";
import { default as first_45time_45freshman_45registration_45rulesCxkdfjMl1j6Zw2d_45CQLzw4VE_45EvFo5tpkBylYxsvox0Meta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/first-time-freshman-registration-rules.vue?macro=true";
import { default as _91slug_93lN_kThdbNGKozeCKcXKviChCIOiD8VoxEBYAj2U6el8Meta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/online-degree-programs/graduate/[slug].vue?macro=true";
import { default as indexjSyUl9QlJevIpoYpS4F54DKCYSc52VkvoHSpk5zq0PEMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/online-degree-programs/certificates/index.vue?macro=true";
import { default as _91slug_93OFw6CtZkf0PeA2iNuVjZQ3eu48a0DIUCWbfpgDTZP2cMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/online-degree-programs/certificates/[slug].vue?macro=true";
import { default as indexzAF9q30KqLicgek_45EIOVe2WEErWBz3IQVz4_KmjsDc8Meta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/online-degree-programs/undergraduate/index.vue?macro=true";
import { default as index_45E6_ud1ygdm8fcEjEIJ_1ospjdn7owdkVZbA5QA6atQMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/degree-program-request-info-thank-you/index.vue?macro=true";
import { default as _91slug_93fVIp6ey0myXX_45G3bkANQygbCcH33_72KCKQhdme_iY0Meta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/online-degree-programs/undergraduate/[slug].vue?macro=true";
import { default as indexHl9OyRx8b73JNSaj5Ukm7kZcHjyYe3_451gxnRDBg8FwwMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/what-it-costs/scholarship-opportunities/index.vue?macro=true";
import { default as indexb7BU2YwdE9QzmSCoQ0sxdFzq9ByAmmoVRX5GjFWNVfYMeta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/degree-program-request-info-thank-you/graduate/index.vue?macro=true";
import { default as indexwnnuh_HYP_454Z81WKRv9uX9wVJLqGjR4jOI4YygVY8w8Meta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/degree-program-request-info-thank-you/undergrad/index.vue?macro=true";
import { default as indexM1qrOoYlvaoejzjgsYoEm8QBmgZrppbK3jQp90Is4B8Meta } from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/degree-program-request-info-thank-you/no-contact-thank-you-page/index.vue?macro=true";
export default [
  {
    name: "200",
    path: "/200",
    meta: _200u3XR9KSpukK1UYL0dV_4B2lhd0_3zC1HSs8KfHtasasMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/200.vue")
  },
  {
    name: "404",
    path: "/404",
    meta: _404iXt53w40RWlZZUZt_2U_GlN3_gQfrKF_X6yKiG5t_45bQMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/404.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexvrLs_45O6MobVvdekuoYB6orLUGYcge2YgmDO9_45eS_452tEMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/index.vue")
  },
  {
    name: "study",
    path: "/study",
    meta: index268lQ_g8gssklqajHfduwtzJ4sruwX18Q_Au6dbvZ_45oMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/study/index.vue")
  },
  {
    name: "about-us-faq",
    path: "/about-us/faq",
    meta: faqLv3495i8HlZp7iI8Ae62uNlyufh99hOxFG1esItSReIMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/about-us/faq.vue")
  },
  {
    name: "study-slug",
    path: "/study/:slug()",
    meta: _91slug_93I_ZDuNiRciiYaTelgU9TN2E7G3er2mM8raBpVeobFR0Meta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/study/[slug].vue")
  },
  {
    name: "chat-with-asu",
    path: "/chat-with-asu",
    meta: chat_45with_45asuwAF4ti5FUPw_45D4NU_45Wmb3U3M7GlxFcbYqVsES_QOgW4Meta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/chat-with-asu.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    meta: indexpsZ3jCJtl_v20MPICfBiLi3JbfybJMXG3QQPK7KhbPUMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/about-us/index.vue")
  },
  {
    name: "newsroom",
    path: "/newsroom",
    meta: indexmPyERBXw3U6ilf4USWIGzVcGan75Y8h6SsiHX27GtcAMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/newsroom/index.vue")
  },
  {
    name: "students",
    path: "/students",
    meta: index2U7R_zGZkZS68N43cXHpoghptZYsQ31mfB_453pCc6FSoMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/index.vue")
  },
  {
    name: "admission",
    path: "/admission",
    meta: indexXWyOwytar70zsOAg_45PsFRihEiuqot3YR9bnAJb0Eos8Meta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/admission/index.vue")
  },
  {
    name: "about-us-faculty",
    path: "/about-us/faculty",
    meta: facultyfEFvNsWNLK6KEcxF8zBgvFTqUfk5snx43TilZVjTsTwMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/about-us/faculty.vue")
  },
  {
    name: "students-courses",
    path: "/students/courses",
    meta: coursesnhgLQhEpZfReDeCSFV2mpKy6Hito7q1g9SaGwmlyY5UMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/courses.vue")
  },
  {
    name: "students-reviews",
    path: "/students/reviews",
    meta: reviews3J0JTXP9GsQDTcwpFZNvocwCHQfUl3N4p8bPWTbh1VgMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/reviews.vue")
  },
  {
    name: "about-us-policies",
    path: "/about-us/policies",
    meta: policiespcvy94K0lNqNcqOAHgoxa22v8qBFgn0FGTCymrc76BkMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/about-us/policies.vue")
  },
  {
    name: "about-us-rankings",
    path: "/about-us/rankings",
    meta: rankingsou0tftUX2_MGiu2i8fMXWmnKhnmD6sA5NFyA7jcU9Y0Meta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/about-us/rankings.vue")
  },
  {
    name: "students-services",
    path: "/students/services",
    meta: servicesOp2wEXnMMlD6CqG62S6_45rat5GHBcyapu6XmTGIRuivIMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/services.vue")
  },
  {
    name: "students-tutoring",
    path: "/students/tutoring",
    meta: tutoringJ1zc3x_JEpN3b_45U3xVRmWCcsc2wimwyNBgoe4vLlgbwMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/tutoring.vue")
  },
  {
    name: "students-community",
    path: "/students/community",
    meta: communityHOp4JhUO_45FlYXUqgmHfJ1DMQUFNPWRLlWU6YMpPHu2kMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/community.vue")
  },
  {
    name: "about-us-contact-us",
    path: "/about-us/contact-us",
    meta: contact_45uspiZU4L6SNN6j6_45QKxass_45VX1rSgqeiS4XTNxPbR2oSUMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/about-us/contact-us.vue")
  },
  {
    name: "join-asu-sun-devils",
    path: "/join-asu-sun-devils",
    meta: join_45asu_45sun_45devilsRb4_Pj6gDQ8OwWOkgXxF8REdSQ4XY2yc_CNvs7U6VTYMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/join-asu-sun-devils.vue")
  },
  {
    name: "what-it-costs",
    path: "/what-it-costs",
    meta: index2YqWgDN0Gr94QZst4cCWeYHtu2HIi12vPSEceSVjLucMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/what-it-costs/index.vue")
  },
  {
    name: "students-online-labs",
    path: "/students/online-labs",
    meta: online_45labsZ2rnx2GQCJmLipYmuVmC5ytNah9sVDtl5_nDJn6vd7IMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/online-labs.vue")
  },
  {
    name: "students-study-abroad",
    path: "/students/study-abroad",
    meta: study_45abroad3ZsA1_45nGSnHDkPyjE9fbPGTMtMPU9X_JvYLNd7yBApgMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/study-abroad.vue")
  },
  {
    name: "students-success-team",
    path: "/students/success-team",
    meta: success_45team9yeKK8Acwhd4y_Ny4Eo6lF_DmyN3MIh7xnYwZMLbax4Meta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/success-team.vue")
  },
  {
    name: "about-us-accreditation",
    path: "/about-us/accreditation",
    meta: accreditationsg2QheBuCt_45vH9xsLZRGPqbfMxo8pAxQU0PnDDbVzl0Meta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/about-us/accreditation.vue")
  },
  {
    name: "admission-slug",
    path: "/admission/:slug()",
    meta: index3ANIoMEkFcqnLXfeMtGpMtGSl5n_45uOxFI90_TB3HPS0Meta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/admission/[slug]/index.vue")
  },
  {
    name: "about-us-why-asu-online",
    path: "/about-us/why-asu-online",
    meta: why_45asu_45online20S9ihkpeRMjLakyXslCIjCQJxNiqfix6APmCRGbzWgMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/about-us/why-asu-online.vue")
  },
  {
    name: "web-analytics-privacy-2",
    path: "/web-analytics-privacy-2",
    meta: web_45analytics_45privacy_452WTn_hd_CJxlWyBgaQ84Vro3ujNBWrXRtIRI2hcvazMwMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/web-analytics-privacy-2.vue")
  },
  {
    name: "newsroom-category",
    path: "/newsroom/:category()",
    meta: index4RJkj9nqnMwVRPhHWIwggjugfC2_45n7DjkriiZO3TAHoMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/newsroom/[category]/index.vue")
  },
  {
    name: "students-graduation-beyond",
    path: "/students/graduation-beyond",
    meta: graduation_45beyond_45qJTkLNffAigdOV70CgL2S_pq6yX4EWCdkryymMDMwsMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/students/graduation-beyond.vue")
  },
  {
    name: "admission-slug-apply",
    path: "/admission/:slug()/apply",
    meta: indexB0isY0wT85uZMdRByM86GpkwLhWQSmajjzcmOlThXAkMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/admission/[slug]/apply/index.vue")
  },
  {
    name: "online-degree-programs",
    path: "/online-degree-programs",
    meta: indexAOC6NVCQ_45zkNInj34mHngRfBrlJY2WuU4sRgbmlUogEMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/online-degree-programs/index.vue")
  },
  {
    name: "admission-nondegree-apply",
    path: "/admission/nondegree/apply",
    meta: indexXCR_VPYR_45N4mZRVFQYgtGKAL3hp25DpY_45ZXGs12WM_45AMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/admission/nondegree/apply/index.vue")
  },
  {
    name: "what-it-costs-financial-aid",
    path: "/what-it-costs/financial-aid",
    meta: indexi1ZJU5jkrOBKI63M0Dfv8y00x__45npj8DKmhAOaymykMMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/what-it-costs/financial-aid/index.vue")
  },
  {
    name: "what-it-costs-loan-estimator",
    path: "/what-it-costs/loan-estimator",
    meta: indexx6wudrs0yUyW0bNlyTHrrdGnarUPDtu7k3gU3qWqqcAMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/what-it-costs/loan-estimator/index.vue")
  },
  {
    name: "newsroom-category-article",
    path: "/newsroom/:category()/:article()",
    meta: indexBmkStZhDPRpWkcAZ0JPkhAFaidCzOda3CqafvEzb_sEMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/newsroom/[category]/[article]/index.vue")
  },
  {
    name: "online-degree-programs-minors",
    path: "/online-degree-programs/minors",
    meta: indexeMT6CqX95g5XeeNK62M8o4t6UvjL_rAIvQ_45_45O2YoBjkMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/online-degree-programs/minors/index.vue")
  },
  {
    name: "online-degree-programs-graduate",
    path: "/online-degree-programs/graduate",
    meta: indexKTOn4dTL4P7iFZPBRceCww7sn9W24EmIrLhP3StjqoMMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/online-degree-programs/graduate/index.vue")
  },
  {
    name: "first-time-freshman-registration-rules",
    path: "/first-time-freshman-registration-rules",
    meta: first_45time_45freshman_45registration_45rulesCxkdfjMl1j6Zw2d_45CQLzw4VE_45EvFo5tpkBylYxsvox0Meta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/first-time-freshman-registration-rules.vue")
  },
  {
    name: "online-degree-programs-graduate-slug",
    path: "/online-degree-programs/graduate/:slug()",
    meta: _91slug_93lN_kThdbNGKozeCKcXKviChCIOiD8VoxEBYAj2U6el8Meta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/online-degree-programs/graduate/[slug].vue")
  },
  {
    name: "online-degree-programs-certificates",
    path: "/online-degree-programs/certificates",
    meta: indexjSyUl9QlJevIpoYpS4F54DKCYSc52VkvoHSpk5zq0PEMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/online-degree-programs/certificates/index.vue")
  },
  {
    name: "online-degree-programs-certificates-slug",
    path: "/online-degree-programs/certificates/:slug()",
    meta: _91slug_93OFw6CtZkf0PeA2iNuVjZQ3eu48a0DIUCWbfpgDTZP2cMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/online-degree-programs/certificates/[slug].vue")
  },
  {
    name: "online-degree-programs-undergraduate",
    path: "/online-degree-programs/undergraduate",
    meta: indexzAF9q30KqLicgek_45EIOVe2WEErWBz3IQVz4_KmjsDc8Meta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/online-degree-programs/undergraduate/index.vue")
  },
  {
    name: "degree-program-request-info-thank-you",
    path: "/degree-program-request-info-thank-you",
    meta: index_45E6_ud1ygdm8fcEjEIJ_1ospjdn7owdkVZbA5QA6atQMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/degree-program-request-info-thank-you/index.vue")
  },
  {
    name: "online-degree-programs-undergraduate-slug",
    path: "/online-degree-programs/undergraduate/:slug()",
    meta: _91slug_93fVIp6ey0myXX_45G3bkANQygbCcH33_72KCKQhdme_iY0Meta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/online-degree-programs/undergraduate/[slug].vue")
  },
  {
    name: "what-it-costs-scholarship-opportunities",
    path: "/what-it-costs/scholarship-opportunities",
    meta: indexHl9OyRx8b73JNSaj5Ukm7kZcHjyYe3_451gxnRDBg8FwwMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/what-it-costs/scholarship-opportunities/index.vue")
  },
  {
    name: "degree-program-request-info-thank-you-graduate",
    path: "/degree-program-request-info-thank-you/graduate",
    meta: indexb7BU2YwdE9QzmSCoQ0sxdFzq9ByAmmoVRX5GjFWNVfYMeta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/degree-program-request-info-thank-you/graduate/index.vue")
  },
  {
    name: "degree-program-request-info-thank-you-undergrad",
    path: "/degree-program-request-info-thank-you/undergrad",
    meta: indexwnnuh_HYP_454Z81WKRv9uX9wVJLqGjR4jOI4YygVY8w8Meta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/degree-program-request-info-thank-you/undergrad/index.vue")
  },
  {
    name: "degree-program-request-info-thank-you-no-contact-thank-you-page",
    path: "/degree-program-request-info-thank-you/no-contact-thank-you-page",
    meta: indexM1qrOoYlvaoejzjgsYoEm8QBmgZrppbK3jQp90Is4B8Meta || {},
    component: () => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/pages/degree-program-request-info-thank-you/no-contact-thank-you-page/index.vue")
  }
]